<template>
  <div class="h-full p-20px">
    <div class="h-full flex flex-column">
      <div class="flex justify-between bg-white-color items-center">
        <Tabs :datas="tabs" class="px-20px bg-white-color" v-model="tab"/>
        <vxe-button v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="showInvoiceVoucherTemplate" type="text" icon="fa fa-gear">生成凭证设置</vxe-button>
      </div>
      <component @import="doImport" @download="doDownload" :is="tab" :categoryList="categoryList[tab]" class="flex-1 bg-white-color flex flex-column"/>
    </div>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

import {mapState} from "vuex";
import OutputInvoice from "@/views/invoice/OutputInvoice";
import IncomeInvoice from "@/views/invoice/IncomeInvoice";
import Cerium from "@/views/invoice/Cerium";
import {computed, h, ref} from "vue";
import {layer} from "@layui/layer-vue";
import InvoiceVoucherTemplate from "@/views/invoice/InvoiceVoucherTemplate";
import {Invoice} from "@/api/Invoice";
import {downloadBlob} from "download.js";
import manba from "manba";
import InvoiceImport from "@/views/invoice/InvoiceImport";
import {heyuiConfig} from "heyui.ext";



// const list = ref([])
//
// const initInvoiceCategory = ()=>{
//   list.value = heyuiConfig.getDict("invoiceCategory");
// }
//
// initInvoiceCategory()
// const categoryList = {
//   /*OutputInvoice: {
//     普通发票: "普通发票",
//     专用发票: "专用发票",
//     机动车发票: "机动车发票",
//     二手车发票: "二手车发票"
//   },*/
//   OutputInvoice: list.value,
//   IncomeInvoice: list.value
// }

export default {
  name: "Invoice",
  components: {Cerium, IncomeInvoice, OutputInvoice},
  data() {
    return {
      tab: "OutputInvoice",
      categoryList:{
        OutputInvoice: heyuiConfig.getDict("invoiceCategory"),
        IncomeInvoice: heyuiConfig.getDict("invoiceCategory")}
    }
  },
  computed: {
    ...mapState(['currentAccountSets','User']),
    tabs() {
      if (this.currentAccountSets.vatType) {
        return {'OutputInvoice': '销项发票', 'IncomeInvoice': '进项发票'}
      } else {
        return {'OutputInvoice': '销项发票', 'IncomeInvoice': '进项发票'}
      }
    }
  },
  methods: {
    showInvoiceVoucherTemplate() {
      layer.drawer({
        title: "凭证模板设置",
        zIndex: 1000,
        area: ['700px', '100vh'],
        content: h(InvoiceVoucherTemplate)
      });
    },
    doImport(args) {
      let layerId = layer.open({
        title: this.tabs[this.tab] + "导入",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(InvoiceImport, {
          type: args.type,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
          }
        })
      });
    },
    doDownload(args) {
      const loadId = layer.load(1);
      Invoice.download(args.type, Object.assign({download: true}, args.params)).then((resp) => {
        downloadBlob(this.tabs[this.tab] + manba().format('YYYYMMDD'), resp);
      }).finally(() => layer.close(loadId));
    }
  },
}
</script>
